import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  ButtonGroup,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import ReactSelect from "react-select";
import { Field, Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Option,
  LimitedChipsContainer,
  CustomOption,
} from "components/Options";
import Calendar from "assets/icon/calendar-icon.svg";
import useAxios from "hooks/useAxios";
import moment from "moment";
import { toast } from "react-toastify";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import Loader from "components/Loader";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import "react-datepicker/dist/react-datepicker.css";
// import EXcelFile from 'assets/images/ReportsType_ExcelFile.xlsx';

import ExcelDownload from "assets/images/ReportsDownload.svg";
import save from "assets/icon/save.svg";
import Dropzone from "react-dropzone";
import file from "assets/icon/file-icon.svg";
import deleteicon from "assets/icon/delete-icon.svg";
// import Tooltip from "react-tooltip-lite";

//let ManufacturerData = [];
// let pharmacyData = [];
// const productlineData = [
//   {
//     productline: "Contract Pharmacy 2.0",
//     casereason: [
//       {
//         name: "User Access Updates",
//         casesubreason: [
//           "Create New User",
//           "MFA Reset",
//           "Other/uknown",
//           "Password Reset",
//           "Remove User",
//           "Unlock User",
//           "Update Access Level",
//           "Update User Information",
//         ],
//       },
//       {
//         name: "Report Request",
//         casesubreason: [
//           "832 catalog Report",
//           "Claims Report",
//           "Crosswalk Report",
//           "Drug (FDB) Report",
//           "Encounter file Report",
//           "Eprescription File Report",
//           "Health Report",
//           "HRSA Audit Report",
//           "Inventory Report",
//           "Invoice Report",
//           "Manufacturer configurations",
//           "Order Report",
//           "Other/uknown",
//           "Pharmacy configurations",
//           "PO file Report",
//           "Provider details",
//           "Service location details",
//           "Switch details",
//           "Wholesaler details",
//         ],
//       },
//       {
//         name: "Provider Updates",
//         casesubreason: [
//           "Add/Term & Reprocess",
//           "Other/uknown",
//           "Panel Updates & Reprocess",
//         ],
//       },
//       {
//         name: "Ordering Updates",
//         casesubreason: [
//           "Add/Remove 810 invoices",
//           "Cancellations",
//           "Claims mapping to orders",
//           "Other/uknown",
//           "Inventory Updates",
//           "Inventory updates",
//           "NDCs not ordering/splitting",
//           "Switching wholesaler accounts",
//         ],
//       },
//       {
//         name: "Vendor Gateway",
//         casesubreason: [
//           "Other/uknown",
//           "Pharmacy Terminations",
//           "PSA Amendment Requests",
//           "Reports Request",
//           "Capture/NonCapture Claims",
//           "Data Issues",
//           "Missing Claims",
//           "Missing Orders",
//           "Order/Replenishment Issues",
//         ],
//       },
//       {
//         name: "Manufacturer Updates",
//         casesubreason: [
//           "Add new Manufacturer/NDCs",
//           "Add/Correct contract exclusions",
//           "Change Manufacutrer blocks",
//           "Other/uknown",
//         ],
//       },
//       {
//         name: "Invoice Adjustments",
//         casesubreason: [
//           "Address changes",
//           "Adjustments",
//           "Missing claims",
//           "Other/uknown",
//         ],
//       },
//       {
//         name: "Research Request",
//         casesubreason: [
//           "Claim Status",
//           "Inventory Status",
//           "Order Status",
//           "Other/uknown",
//           "Provider/Patient Status",
//         ],
//       },
//       {
//         name: "Other Support",
//         casesubreason: ["Other/uknown"],
//       },
//       {
//         name: "Configuration Changes",
//         casesubreason: [
//           "Configuration - Other/unknown",
//           "FM Sheet - Research Request",
//           "Catalog - NDC Updates",
//           "Catalog - OTCs",
//           "Claims - Capture/Uncapture",
//           "Claims - Other/unknown",
//           "Claims - Quanity Updates",
//           "Claims - Reprocessing",
//           "Claims - True-up",
//           "Data File - Conversion factors",
//           "Data File - Other/unknown",
//           "Dispense Fee - Reprocess & gateway adjustments",
//           "Dispense Fee - Update",
//           "BIN/PCN/GROUP - Add, backdate",
//           "BIN/PCN/GROUP - Add, backdate, reprocess",
//           "BIN/PCN/GROUP - Other/unknown",
//           "BIN/PCN/GROUP - Term, backdate",
//           "BIN/PCN/GROUP - Term, backdate, reprocess",
//           "BIN/PCN/GROUP - Term, backdate, uncapture, reprocess",
//           "Catalog - Other/unknown",
//           "Claims - Add/Correct, reprocess",
//           "Claims - Add/correct, reprocess, gateway adjustments",
//           "Claims - Add/correct, reprocess, invoice adjustments",
//           "Claims - Missing COB claims",
//           "Claims - Transfer claims",
//           "Configuration - Termination",
//           "Data File - Credit memos",
//           "Data File - Missed files",
//           "Dispense Fee - Other/unknown",
//           "Dispense Fee - Reprocess",
//           "Dispense Fee - Reprocess & invoice adjustments",
//           "FM Sheet - Contract Changes",
//           "FM Sheet - Data Correction",
//           "FM Sheet - Other/unknown",
//           "FM Sheet - Regenerate",
//           "FM Sheet - Update Entities",
//           "FM Sheet - Update Pharmacies",
//         ],
//       },
//     ],
//   },
//   {
//     productline: "Split Billing 3.0",
//     casereason: [
//       {
//         name: "User Access Updates",
//         casesubreason: [
//           "Create New User",
//           "MFA Reset",
//           "Other/uknown",
//           "Password Reset",
//           "Remove User",
//           "Unlock User",
//           "Update Access Level",
//           "Update User Information",
//         ],
//       },
//       {
//         name: "Report Request",
//         casesubreason: [
//           "Drug Utilization Report",
//           "HRSA Audit Report",
//           "Location report",
//           "Other/uknown",
//           "Pending claims report",
//           "PO split report",
//           "Purchase Report",
//         ],
//       },
//       {
//         name: "Payor/Location Updates",
//         casesubreason: ["Modify effective date & reprocess", "Other/uknown"],
//       },
//       {
//         name: "Ordering Updates",
//         casesubreason: [
//           "Add Manual Wholesaler",
//           "Add/Change Wholesalers for EDI",
//           "Change Account Type on PO",
//           "Change PO status",
//           "Change the NDC for PO",
//           "Missing 810s/PO discrepancy",
//           "Other/uknown",
//           "PO cancellations",
//         ],
//       },
//       {
//         name: "Other Support",
//         casesubreason: ["Other/uknown"],
//       },
//       {
//         name: "Configuration Changes",
//         casesubreason: [
//           "Data File - Update, reprocess",
//           "Configuration - Other/unknown",
//           "Crosswalk - Add/change",
//           "Crosswalk - BUPP update, reprocess",
//           "Crosswalk - Charge code/NDC update",
//           "Crosswalk - Claims reprocess",
//           "Crosswalk - Edit effective dates",
//           "Crosswalk - Other/unknown",
//           "Crosswalk - Remove mapping",
//           "Data File - Drug utilization updates",
//           "Data File - Other/unknown",
//           "Data File - Update HI conversion factors",
//           "Data File - Upload credit memos",
//           "Data File - Upload missed files",
//           "Drug List - Exclude/include",
//           "Drug List - Orphan Drug list",
//           "Drug List - Other/unknown",
//         ],
//       },
//     ],
//   },
//   {
//     productline: "Split Billing 2.0",
//     casereason: [
//       {
//         name: "User Access Updates",
//         casesubreason: [
//           "Create New User",
//           "MFA Reset",
//           "Other/uknown",
//           "Password Reset",
//           "Remove User",
//           "Unlock User",
//           "Update Access Level",
//           "Update User Information",
//         ],
//       },
//       {
//         name: "Report Request",
//         casesubreason: [
//           "Drug Utilization Report",
//           "HRSA Audit Report",
//           "Location report",
//           "Other/uknown",
//           "Pending claims report",
//           "PO split report",
//           "Purchase Report",
//         ],
//       },
//       {
//         name: "Payor/Location Updates",
//         casesubreason: ["Modify effective date & reprocess", "Other/uknown"],
//       },
//       {
//         name: "Ordering Updates",
//         casesubreason: [
//           "Add Manual Wholesaler",
//           "Add/Change Wholesalers for EDI",
//           "Change Account Type on PO",
//           "Change PO status",
//           "Change the NDC for PO",
//           "Missing 810s/PO discrepancy",
//           "Other/uknown",
//           "PO cancellations",
//         ],
//       },
//       {
//         name: "Other Support",
//         casesubreason: ["Other/uknown"],
//       },
//       {
//         name: "Configuration Changes",
//         casesubreason: [
//           "Data File - Update, reprocess",
//           "Configuration - Other/unknown",
//           "Crosswalk - Add/change",
//           "Crosswalk - BUPP update, reprocess",
//           "Crosswalk - Charge code/NDC update",
//           "Crosswalk - Claims reprocess",
//           "Crosswalk - Edit effective dates",
//           "Crosswalk - Other/unknown",
//           "Crosswalk - Remove mapping",
//           "Data File - Drug utilization updates",
//           "Data File - Other/unknown",
//           "Data File - Update HI conversion factors",
//           "Data File - Upload credit memos",
//           "Data File - Upload missed files",
//           "Drug List - Exclude/include",
//           "Drug List - Orphan Drug list",
//           "Drug List - Other/unknown",
//         ],
//       },
//     ],
//   },
// ];

const AddConfigurations = ({
  manvalPharacy,
  Loading,
  setLoading,
  refetch,
  submit,
}) => {
  const API = useAxios();
  const [coveredEntitiesData, setcoveredEntitiesData] = useState([]);
  const [celist, setCelist] = useState();

  const [selectedProductline, setSelectedProductline] = useState("");
  const [selectedCasereason, setSelectedCasereason] = useState("");
  const [selectedCasesubreason, setSelectedCasesubreason] = useState("");

  const [caseReasons, setCaseReasons] = useState([]);
  const [caseSubreasons, setCaseSubreasons] = useState([]);
  const [productlineData, setProductLineData] = useState([]);
  const [selectedcoveredEntity1, setSelectedCoveredEntity] = useState([]);
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  //  const [error, setError] = useState(false)

  const [selectedCEOption, setCEOptionSelected] = useState({
    optionCESelected: "-1",
  });
  const [error, setError] = useState(false);
  const [errorsize, setErrorsize] = useState(false);
  const getSessionStorageDetails = () => {
  return JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
};
const { token_type, access_token,profile } = getSessionStorageDetails();
  const decodetoken=access_token

  const handleProductlineChange = (e) => {
    const value = e.target.value;
    setSelectedProductline(value);
    setSelectedCasereason("");
    setSelectedCasesubreason("");

    const found = productlineData.find((p) => p.productLineName === value);
    if (found) {
      setCaseReasons(found.caseReasons);
    } else {
      setCaseReasons([]);
    }
    setCaseSubreasons([]);
  };

  const handleCasereasonChange = (e) => {
    const value = e.target.value;
    setSelectedCasereason(value);
    setSelectedCasesubreason("");

    const found = caseReasons.find((r) => r.caseReasonName === value);
    setCaseSubreasons(found ? found.caseSubReasons : []);
  };

  const handleCasesubreasonChange = (e) => {
    setSelectedCasesubreason(e.target.value);
  };
  const CaseOptions = async () => {
    try {
      const { data } = await API.get("api/Search/caseoptions", {
        hasDefaultURL: true,
      });
      setProductLineData(data.productLines);
      // console.log(data, "data");
    } catch (error) { }
  };
  const fetchCoveredntity = async () => {
    setLoading(true);
    try {
      //  if (filters.ApplicationId && filters.ReportTypeId &&filters.coveredEntityIDs) {
      const { data } = await API.get(`api/Search/celist`, {
        hasDefaultURL: true,
      });
      if (data) {
        for (var x in data) {
          coveredEntitiesData.push({
            value: data[x].ceCode,
            label: data[x].ceName,
          });
        }
        // ceflag = true
        setLoading(false);

        setCelist(data);
      } else {
        setCelist([]);
        setLoading(false);
      }
      // console.log(data, "data");
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoveredntity();
  }, []);
  const handlece = (selected) => {
    const target = selected.target.value;
    // console.log(selected.target.value);
    if (target == "") {
      setCEOptionSelected({
        optionCESelected: -1,
      });
    }
    else {
      setCEOptionSelected({
        optionCESelected: target,
      });
      CaseOptions();
    }
  };
  const handelsubject = (e) => {
    const target = e.target.value;
    setSubject(target);
  };
  const handelDescrption = (e) => {
    const target = e.target.value;
    setDescription(target);
  };
  const coveredentity = [{ id: 101, Name: "Contract Pharmacy" }];

  
  const [selectedFile, setSelectedFile] = useState([]);
  const [base64, setBase64] = useState([]);

  const MaxSize = 15 * 1024 * 1024;

  
  const onHandleFileChange = (acceptedFiles) => {
    if (!acceptedFiles || acceptedFiles.length === 0) return;
    setError(false)
setErrorsize(false)
    const file = acceptedFiles[0];
    console.log(file.size,"size")

    const isUnsupported = /\.(ppt|pptx)$/i.test(file.name);
    if (isUnsupported) {
      //  alert("PowerPoint files (.ppt, .pptx) are not supported.");
      setSelectedFile([])
      setError(true);
      return;
    }

    if (file.size > MaxSize) {
      //  alert("File size exceeds the maximum allowed limit.");
      setSelectedFile([])
      setErrorsize(true);
      return;
    }

    file.id = Math.floor(Math.random() * 1000000);
    setSelectedFile([file]);

    const reader = new FileReader();
    setError(false)
    setErrorsize(false)

    reader.onloadend = () => {
      const base64Only = reader.result.split(",")[1];
      setBase64([{ id: file.id, base64: base64Only }]);
      setError(false);
      setErrorsize(false)

    };
    reader.onerror = (error) => {
      console.error("File reading error:", error);
      // setError(true);
    };
    reader.readAsDataURL(file);
  };
  console.log(error, "error")

  const handleSubmit = async () => {
    // debugger;
    // e.preventDefault()
    let paylod = {};
    (paylod.subject = subject),
      (paylod.description = description),
      (paylod.productLine = selectedProductline),
      (paylod.caseReason = selectedCasereason),
      (paylod.subReason = selectedCasesubreason),
      (paylod.x340BID = selectedCEOption.optionCESelected);
      (paylod.customerEmail=profile.username)
    // if (selectedFile) {
    //   paylod.fileAttachments = [
    //     {
    //       fileType: selectedFile ? selectedFile?.type : "",
    //       fileName: selectedFile ? selectedFile?.name : "",
    //       base64Data: base64 ? base64 : "",
    //     },
    //   ];
    // } else {
    //   paylod.fileAttachments = [];
    // }
     var sizefile=""
    if (selectedFile && selectedFile.length > 0 && base64.length > 0) {
      paylod.fileAttachments = selectedFile.map((file) => {
        const filename = file.name
        const filesize=file.size
        const minfilesize=2*1024*1024
        const filesplit = filename.split(".")[0]
       
        if(filesize<minfilesize){
          sizefile=2
        }
        else{
          sizefile=3
        }
        // const filtetype=file.name.split(".")[1]
        // console.log(filtetype,"type")
        const fileName = selectedFile[0]?.name;
        const nameBeforeExtension = fileName?.substring(0, fileName.lastIndexOf("."));
        console.log(nameBeforeExtension, "name")

        const extension = fileName?.substring(fileName.lastIndexOf(".") + 1);

        const matchingBase64 = base64.find((b64) => b64.id === file.id);
        return {
          fileType: extension || "",
          fileName: sizefile==2? nameBeforeExtension:fileName || "",
          base64Data: matchingBase64 ? matchingBase64.base64 : "",
          fileSize:filesize
        };
      });
    } else {
      paylod.fileAttachments = [];
    }

    setLoading(true);
    try {
      
      const data = await API.post("api/Search/addcase", paylod, {
        hasDefaultURL: true,
      });
      if (data?.data.status == "Success") {
        toast.success(data?.data.message);
      } else if (data?.data.status == "Error") {
        toast.success(data?.data.message);
      }
      manvalPharacy();
      setLoading(false);
      // console.log(data, "data");
    } catch (error) {
      setLoading(false);
    }
    submit();
    setLoading(true);
  };
  const handelRemovePDF = (item) => {
    console.log(item,"item")
    const removepdf = selectedFile.filter((value) => value.id != item.id);
    console.log(removepdf, "removepdf");
    setSelectedFile(removepdf);
  };
  console.log(selectedCEOption.optionCESelected,
    selectedProductline.length,
    selectedCasereason.length,
    selectedCasesubreason.length, "case")
  console.log(selectedCasereason.length == 0);

  const FileNameLength =
    selectedFile.length > 0 &&
    selectedFile.some((file) => file.name.length > 0);
const getWordCount = (str) => str.trim().split(/\s+/).length

  return (
    <div>
      <Formik
        onSubmit={handleSubmit}
        initialValues={{}}
        enableReinitialize={true}
        children={(props) => {
          //const { handleSubmit } = props;
          return (
            <div>
              {/* {Loading && <Loader opacity={0.01} color="black" />} */}
              <Card
                className="add-info"
                style={{
                  // height: "calc(100vh - 100px)",
                  background: "transparent",
                  border: "none",
                }}
              >
                <CardBody>
                  <div>
                    <Row>
                      <Col md={6} lg={6} sm={6} xs={6}>
                        <FormGroup>
                          <Label
                            htmlFor="coveredEntityIDs"
                            for="coveredEntityIDs"
                            className=""
                          >
                            Covered Entity/OPAID
                          </Label>
                          <Field
                            name="coveredEntityIDs"
                            type="text"
                            onChange={(e) => handlece(e)}
                            value={selectedCEOption.optionCESelected}
                            component={FormikSelectField}
                            options={coveredEntitiesData}
                            defaultoption="Select"
                            keys={{
                              id: "value",
                              label: "label",
                            }}
                          />

                          {/* {(error) && (selectedcoveredEntity1 == '' || selectedcoveredEntity1 === undefined) && <div className="text-danger f-12">
                                                Covered Entity name is required</div>} */}
                        </FormGroup>
                      </Col>

                      <Col md={6} lg={6} sm={6} xs={6}>
                        <FormGroup>
                          <Label
                            htmlFor="productLineName"
                            for="productLineName"
                            className=""
                          >
                            Product Line
                          </Label>
                          <Field
                            name="productLineName"
                            type="text"
                            disabled={!productlineData.length}
                            // value={"ceid"}
                            // onChange={(e) => handleCeChange(e)}
                            onChange={handleProductlineChange}
                            component={FormikSelectField}
                            options={productlineData}
                            value={selectedProductline}
                            defaultoption="Select"
                            keys={{
                              id: "productLineName",
                              label: "productLineName",
                            }}
                          />
                          {/* {(error) && (ceid == '' || ceid == undefined) && <div className="text-danger f-12">
                                          Covered Entity name is required </div>} */}
                        </FormGroup>
                      </Col>
                      <Col md={6} lg={6} sm={6} xs={6}>
                        <FormGroup>
                          <Label
                            htmlFor="casereason"
                            for="casereason"
                            className=""
                          >
                            Case Reason
                          </Label>
                          <Field
                            name="casereason"
                            type="text"
                            value={selectedCasereason}
                            onChange={handleCasereasonChange}
                            disabled={!caseReasons.length}
                            // value={"ceid"}
                            // onChange={(e) => handleCeChange(e)}
                            component={FormikSelectField}
                            options={caseReasons}
                            defaultoption="Select"
                            keys={{
                              id: "caseReasonName",
                              label: "caseReasonName",
                            }}
                          />
                          {/* {(error) && (ceid == '' || ceid == undefined) && <div className="text-danger f-12">
                                          Covered Entity name is required </div>} */}
                        </FormGroup>
                      </Col>

                      <Col md={6} lg={6} sm={6} xs={6}>
                        <FormGroup>
                          <Label
                            htmlFor="casesubreason"
                            for="casesubreason"
                            className=""
                          >
                            Case Sub Reason
                          </Label>
                          {/* <Field
                          name="covereEntity"
                          type="text"
                          value={selectedCasesubreason}
                          onChange={handleCasesubreasonChange}
                          disabled={!caseSubreasons.length}
                          // value={"ceid"}
                          // onChange={(e) => handleCeChange(e)}
                          component={FormikSelectField}
                          options={caseSubreasons}
                          defaultoption="--select--"
                          keys={{
                            id: "id",
                            label: "Name",
                          }}
                        /> */}
                          <Input
                            id="casesubreason"
                            type="select"
                            value={selectedCasesubreason}
                            onChange={handleCasesubreasonChange}
                            disabled={!caseSubreasons.length}
                            className="form-control"
                          >
                            <option value="">Select</option>
                            {caseSubreasons.map((sub, index) => (
                              <option key={index} value={sub}>
                                {sub}
                              </option>
                            ))}
                          </Input>
                          {/* {(error) && (ceid == '' || ceid == undefined) && <div className="text-danger f-12">
                                          Covered Entity name is required </div>} */}
                        </FormGroup>
                      </Col>
                      <Col md={12} lg={12} sm={12} xs={12}>
                        <FormGroup>
                          <Label for="subject">Subject</Label>
                          <Input
                            id="subject"
                            name="subject"
                            type="text"
                            value={subject}
                            // disabled={!selectedCasesubreason.length}
                            onChange={handelsubject}
                            placeholder="Enter Subject here"
                            autoComplete="off"
                          />
                        </FormGroup>
                      </Col>

                      <Col md={12} lg={12} sm={12} xs={12}>
                        <FormGroup>
                          <Label for="descrption">Description</Label>
                          <Input
                            id="descrption"
                            name="descrption"
                            type="textarea"
                            onChange={handelDescrption}
                            value={description}
                            placeholder="Enter Description here"
                            // disabled={!selectedCasesubreason.length}
                            autoComplete="off"
                            // className="de-textarea"
                            className={FileNameLength ? "de-withAttachment" : "de-textarea"}
                          />
                        </FormGroup>
                      </Col>

                      {/* <Col md={12} lg={12} sm={12} xs={12}>
                      <FormGroup>
                        <Label>Attachment</Label>
                        <Dropzone onDrop={onHandleFileChange} multiple={false}>
                          {({ getRootProps, getInputProps, isDragActive }) => (
                            <section
                              className={`drop-zone ${
                                isDragActive ? "active" : ""
                              }`}
                            >
                              <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <div className="browse">
                                  <Button className="highlight font-weight-600">
                                    <span className="right_5">
                                      {" "}
                                      <img src={file} alt="" />
                                    </span>{" "}
                                    Choose File
                                  </Button>
                                  <span>Drag and drop attachment or</span>
                                </div>
                              </div>
                            </section>
                          )}
                        </Dropzone>

                        {files?.length > 0 && (
                                                        // return <div key={item.name}>{item.name}</div>
                                                        <div>
                                                            {files.map((item) => {
                                                                return <div key={item.name}>{item.size > MaxSize ? (
                                                                    <ErrorMessage>
                                                                        {'File attached should not be greater than 5MB'}
                                                                    </ErrorMessage>
                                                                ) : item.name}</div>;
                                                            })}
                                                        </div>
                                                    )}
                      </FormGroup>
                    </Col> */}
                      <Col md={12} lg={12} sm={12} xs={12}>
                        <FormGroup>
                          <Label>Attachment</Label>
                          <Dropzone
                            onDrop={onHandleFileChange}
                            multiple={false}
                          >
                            {({
                              getRootProps,
                              getInputProps,
                              isDragActive,
                            }) => (
                              <section
                                className={`drop-zone ${isDragActive ? "active" : ""
                                  }`}
                              >
                                <div {...getRootProps()}>
                                  <input {...getInputProps()} />
                                  <div className="browse">
                                    <Button className="highlight font-weight-600">
                                      <span className="right_5">
                                        <img src={file} alt="upload icon" />
                                      </span>
                                      Choose File
                                    </Button>
                                    <span>or Drag and Drop Attachment </span>
                                  </div>
                                </div>
                              </section>
                            )}
                          </Dropzone>

                          {/* Show selected file name */}
                          {selectedFile.length > 0 && (
                            <div className="" style={{ paddingTop: "4px", }}>
                              <strong>Selected File : </strong>{" "}


                              {selectedFile.map((item) => {

                                return (
                                  <>
                                    <div className="">
                                      <div className="d-flex add_atc">
                                        <p color="primary" className="" style={{ marginBottom: "0px", paddingLeft: "0px" }}> {item.name}</p>
                                        <span className="" style={{ paddingLeft: "8px", cursor: "pointer", }} onClick={() => handelRemovePDF(item)}>
                                          <img style={{ position: "relative", top: "-2px", }} src={deleteicon} />

                                          {""}{" "}
                                        </span>
                                      </div>
                                      

                                    </div>
                                  </>
                                );
                              })}

                            </div>
                          )}
                          {/* single file data */}
                          {/* {selectedFile.length > 0 && (
                            <div>
                              <strong style={{ float: "left" }}>
                                Selected File:{" "}
                              </strong>

                              <div style={{ float: "left" }}>
                                <div className="d-flex">
                                  <p
                                    className=""
                                    style={{
                                      marginBottom: "0px",
                                      paddingLeft: "12px",
                                    }}
                                  >
                                    {selectedFile[0].name}
                                  </p>

                                  <div
                                    className=""
                                    style={{
                                      paddingLeft: "12px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      handelRemovePDF(selectedFile[0])
                                    }
                                  >
                                    <img src={deleteicon} alt="Delete" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )} */}


                          {/* {error == true && ( */}
                          {error == true &&
                            <div className="text-danger f-12">
                              PowerPoint files (.ppt, .pptx) are not supported.
                            </div>
                          }
                          {/* )} */}
                          {errorsize == true && (
                            // return <div key={item.name}>{item.name}</div>
                            <div className="text-danger f-12 pt-1" style={{width:"80%"}}>
                              {/* File attached should not be greater than 15MB */}
                              Attached files cannot be greater than 15 MB.  Please contact the client support team by calling <a href="tel:888-519-8057">888-519-8057</a> or email <a href="mailto:support@thepharmaforce.com">support@thepharmaforce.com</a>
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <div>
                <footer>
                  <div hidden={""}>
                    <Row>
                      <Col
                        sm={0}
                        className="d-flex"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Label>{""}</Label>
                        <Button
                          color="primary"
                          className="search"
                          disabled={
                            // selectedCEOption.length == 0 &&
                            selectedCEOption.optionCESelected == -1 ||
                            selectedProductline == "" ||
                            selectedCasereason == "" ||
                            selectedCasesubreason == ""
                            // description.length > 0 &&
                            // subject.length > 0
                          }
                          onClick={handleSubmit}
                        >
                          <span className="right_5">
                            <img src={save} alt="" />
                          </span>{" "}
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </footer>
              </div>
            </div>
          );
        }}
      ></Formik>
    </div>
  );
};

export default AddConfigurations;
